import { rem } from "polished";
import styled from "styled-components";

import { color } from "emoreg/const";

const sizesMapping = {
  small: {
    height: 18,
    width: 32,
  },
  medium: {
    height: 24,
    width: 52,
  },
};

const SwitchStyledContainer = styled.div(({ checked, disabled, size }) => ({
  position: "relative",
  overflow: "hidden",
  width: rem(sizesMapping[size].width),
  height: rem(sizesMapping[size].height),
  borderRadius: rem(sizesMapping[size].height),
  border: `${rem(1)} solid ${color.grey[disabled ? "dark" : "base"]}`,
  backgroundColor: checked
    ? color.blue[disabled ? "dark" : "base"]
    : color.grey[disabled ? "dark" : "base"],
  transition: "background-color 125ms ease-in-out",
  cursor: disabled ? "not-allowed" : "pointer",
}));

const SwitchStyledToggle = styled.div(({ checked, disabled, size }) => {
  const width = sizesMapping[size].height - 8;
  return {
    position: "absolute",
    top: rem(3),
    bottom: rem(3),
    left: rem(3),
    width: rem(width),
    boxSizing: "border-box",
    borderRadius: "50%",
    transform: `translateX(${rem(checked ? sizesMapping[size].width - width - 8 : 0)})`,
    transition: "transform 125ms ease-in-out",
    backgroundColor: disabled ? color.grey.light : "white",
    pointerEvents: "none",
  };
});

export type InputSwitchProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> & {
  size?: "small" | "medium";
};

export const InputSwitch = ({ checked, disabled, onClick, size = "medium" }: InputSwitchProps) => (
  <SwitchStyledContainer onClick={onClick} checked={checked} disabled={disabled} size={size}>
    <SwitchStyledToggle checked={checked} disabled={disabled} size={size} />
  </SwitchStyledContainer>
);
